import React,{Component} from 'react';
import './SignupCourier.css';
import axios from 'axios'
import Navbar from '../../Components/Navbar/Navbar'
import {LinkAPI} from '../../../API/API'
import HandleRes from '../../Components/HandleRes/HandleRes';
import Footer from '../../Components/Footer/Footer'

class SignupCourier extends Component{
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            phone: "",
            password: "",
            confirmpassword: "",
            vehicletypeselect: "",
            nameError: "",
            emailError: "",
            phoneError: "",
            passwordError: "",
            confirmpasswordError: "",
            vehicletypeselectError:"",
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
        }
    } 
    handleChange = event => {
        const isCheckbox = event.target.type === "checkbox";
        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        });
    };

    validate = () => {
        let nameError = "";
        let emailError = "";
        let phoneError = "";
        let passwordError = "";
        let confirmpasswordError="";
        let vehicletypeselectError=""
        if (this.state.name.length < 2||!isNaN(this.state.name)) {
            nameError = "write your name correct";
        }
        if (this.state.password.length < 8) {
            passwordError = "Use 8 characters or more for your password";
        }
        if (isNaN(this.state.phone)||this.state.phone.length < 10 ||this.state.phone.length > 11 ) {
            phoneError = "invalid phone Numper";
        }
        if (this.state.vehicletypeselect==="") {
            vehicletypeselectError = "select vehicle type ";
        }
        
        if (this.state.vehicletypeselect!=="car"&&this.state.vehicletypeselect!=="van"&&this.state.vehicletypeselect!=="motorcycle") {
            vehicletypeselectError = "choose payment  ";
        }
        
        if (this.state.confirmpassword.length < 8 || this.state.password !== this.state.confirmpassword) {
            confirmpasswordError = "Those passwords didn't match. Try again.";
        }

        if (!this.state.email.includes("@")) {
            emailError = "invalid email";
        }

        if (nameError||emailError || passwordError||phoneError||confirmpasswordError||vehicletypeselectError) {
            this.setState({ nameError, emailError,  passwordError,vehicletypeselectError, confirmpasswordError,phoneError });
            return false;
        }

        return true;
    };

    handleSubmit = event => {
        event.preventDefault();
        const {name, phone, email, password,vehicletypeselect}=this.state
        const isValid = this.validate();
        if (isValid) {
            axios.post(`${LinkAPI}/api/courier/signup`,{  name, phone:20+phone.replace(/^0+/, ''), email, password,vehicletypeselect}).then(res =>{
                localStorage.setItem("userTokentConfirmData",res.data.courier.token)
                
                window.location.replace("/Courier/ConfirmPhone");
                }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true,
                    })
                } else if (error.response.data.message) {
                    this.setState({
                        nameError: "",
                        emailError: "",
                        phoneError: "",
                        passwordError: "",
                        confirmpasswordError: "",
                        vehicletypeselectError:"",
                        errordatamessage: true,
                        errordatamessageText: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
                })
        }
    };
    render(){
        document.title ="Kayn | Sign Up"; 
        document.getElementsByTagName("META")[1].content="Kayn Sign Up";
        document.documentElement.lang = 'en';
        return(
            <div className=" AppEN signup">
            <Navbar/>
            <div className='container'>
                <div className="SignupCourier  row">
                <div className="logoform col-6 d-flex align-content-end flex-wrap">
                <div className="contantcover col  text-white p-5">
                            <p className="fontsize10 ml-5 mb-3 font-weight-bold bluecolor">Loco Pack</p>
                            <p className="fontsize11 ml-5 mb-1 font-weight-bold bluecolor">Safe delivery...sure earning</p>
                    </div>
                    </div>

                    <div className="col-md-6 form float-md-right  ">
                       <div className="contantform text-center p-4 ">
                            <h3 className="fontsize1 my-4">Sign up </h3>
                            <p className="fontsize6 my-3">Sign in to continue access pages</p>
                            <form className="px-lg-5" onSubmit={this.handleSubmit}>
                                    <div className="form-group my-3">
                                        <input type="text" className={"form-control badge-pill p-3 " + (this.state.nameError ? 'is-invalid' : '')} placeholder="Full Name" name="name" value={this.state.name} onChange={this.handleChange} required/>
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.nameError}
                                        </div>
                                    </div>
                                    <div className="form-group my-3">
                                        <input type="email" className={"form-control badge-pill p-3 " + (this.state.emailError ? 'is-invalid' : '')} placeholder="Email Adderss" name="email" value={this.state.email} onChange={this.handleChange} required/>
                                        <div style={{ fontSize: 12, color: "red" ,}}>
                                            {this.state.emailError}
                                        </div>
                                    </div>
                                    <div className="form-group my-3 nocounter">
                                    <div className="relative">
                                        <span className="codephone">+20</span>
                                        <input type="number" className={"form-control badge-pill pl-5 p-3 " + (this.state.phoneError ? 'is-invalid' : '')} placeholder="phone" name="phone" value={this.state.phone} onChange={this.handleChange}required />
                                        </div>

                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.phoneError}
                                        </div>
                                    </div>
                                    <div className="form-group my-3">
                                <select id="inputState" className="form-control  badge-pill " name="vehicletypeselect" value={this.state.vehicletypeselect} onChange={this.handleChange}required>
                                    <option value="">Choose</option>
                                    <option value="car">CAR </option>
                                    <option value="van">VAN</option>
                                    <option value="motorcycle">MOTORCYCLE</option>
                                </select>    
                                <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.vehicletypeselectError}
                                        </div>              
                            </div>
                                    <div className="form-group my-3">
                                        <input type="password" className={"form-control badge-pill p-3 " + (this.state.passwordError ? 'is-invalid' : '')} placeholder=" password" name="password" value={this.state.password} onChange={this.handleChange} required/>
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.passwordError}
                                        </div>
                                    </div>
                                    <div className="form-group my-3">
                                        <input type="password" className={"form-control badge-pill p-3 " + (this.state.confirmpasswordError ? 'is-invalid' : '')} placeholder="confirm password" name="confirmpassword" value={this.state.confirmpassword} onChange={this.handleChange}required />
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.confirmpasswordError}
                                        </div>
                                    </div>
                                    {(this.state.errordatamessage ?
                      <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                        {this.state.errordatamessageText}
                      </div> : '')}
                                    <button type="submit" className="btn badge-pill btn-block shadow p-2 mb-2"  >SIGN UP</button>
                                </form> 
                        
                       </div>
                    </div>
                </div>
            </div>
            <Footer/>
            {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default SignupCourier;